import { useState } from 'react';
import './CopyButton.css';

export const CopyButton = ({ targetSelector, label = 'Copy' }) => {
  const [copied, setCopied] = useState(false);

  const formatTableData = (tableElement) => {
    const rows = [];
    
    // Get header row
    const headerCells = tableElement.querySelectorAll('.table__header-cell');
    if (headerCells.length > 0) {
      const headerRow = Array.from(headerCells)
        .map(cell => cell.textContent.trim())
        .join('\t');
      rows.push(headerRow);
    }
    
    // Get data rows
    const dataRows = tableElement.querySelectorAll('.table__row');
    dataRows.forEach(row => {
      const cells = row.querySelectorAll('.table__cell');
      const rowData = Array.from(cells)
        .map(cell => cell.textContent.trim())
        .join('\t');
      rows.push(rowData);
    });
    
    return rows.join('\n');
  };

  const handleCopy = async () => {
    try {
      // Find the target element
      const targetElement = document.querySelector(targetSelector);
      
      if (!targetElement) {
        console.error(`Element with selector "${targetSelector}" not found`);
        return;
      }

      let textContent;
      
      // Check if target is a table
      if (targetElement.classList.contains('table') || targetElement.querySelector('.table')) {
        const tableEl = targetElement.classList.contains('table') 
          ? targetElement 
          : targetElement.querySelector('.table');
        textContent = formatTableData(tableEl);
      } else {
        // Extract regular text content
        textContent = targetElement.innerText || targetElement.textContent;
      }

      // Copy to clipboard
      await navigator.clipboard.writeText(textContent);

      // Show feedback
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <button 
      className="copy-button" 
      onClick={handleCopy}
      aria-label={label}
    >
      <svg
        className="copy-button__icon"
        width="12"
        height="12"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 6.75H8.25C7.42157 6.75 6.75 7.42157 6.75 8.25V15C6.75 15.8284 7.42157 16.5 8.25 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V8.25C16.5 7.42157 15.8284 6.75 15 6.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 11.25H3C2.60218 11.25 2.22064 11.092 1.93934 10.8107C1.65804 10.5294 1.5 10.1478 1.5 9.75V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9.75C10.1478 1.5 10.5294 1.65804 10.8107 1.93934C11.092 2.22064 11.25 2.60218 11.25 3V3.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="copy-button__label">{copied ? 'Copied!' : label}</span>
    </button>
  );
};

